<template>
  <use
    v-show="isUnavailable"
    :width="iconSize"
    :height="iconSize"
    :transform="iconTransform"
    xlink:href="#pin-spot-full"
  />
</template>

<script>
export default {
  props: {
    spot: {
      type: Object,
      required: true,
    },
    visualizationPinSize: {
      type: Object,
      default: () => ({
        width: 0,
        height: 0,
      }),
    },
    visualizationPinScale: {
      type: Number,
      default: 1,
    },
    isSearched: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconSize: ({ visualizationPinSize }) => visualizationPinSize.width * 0.66,
    iconTransform() {
      const x = this.iconSize - this.visualizationPinSize.width / 2;
      const y = -this.visualizationPinSize.height * 1.3;
      return `scale(${this.visualizationPinScale}) translate(${x}, ${y})`;
    },
    numberOfSeats: ({ spot }) => spot.numberOfSeats,
    numberOfPerson() {
      const number = this.spot.spotState ? Number(this.spot.spotState.numberOfPerson) : 0;
      return number > this.numberOfSeats ? this.numberOfSeats : number;
    },
    isUnavailable() {
      return this.numberOfPerson >= this.numberOfSeats;
    },
  },
};
</script>



// WEBPACK FOOTER //
// icon_full.vue?19f7cbfe